import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { FormFieldConfig } from '../dynamic-component-shared/dropdown/form_field_config';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.css'],
})
export class TextEditorComponent implements OnInit {

  @Input() public content: any;
  @Input() config: FormFieldConfig;
  @Input() data: any;
  editMode: boolean = true;
  value: any;
  typeName: any;


  @Output() sendContent = new EventEmitter<any>();

  htmlContent: string = '';

  EditorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    sanitize: false,
    defaultFontName: 'Roboto',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'poppins', name: 'Poppins' },
      { class: 'roboto', name: 'Roboto' }
    ],
    toolbarHiddenButtons: [['insertVideo']],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  };
  constructor() { }

  ngOnInit(): void {
    this.htmlContent = this.content
    this.updateEditorConfig();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['config']) {
      this.config = changes['config'].currentValue;
      this.value = this.config.value;
      this.content = this.value
      this.editMode = this.config.editMode;
      this.typeName = this.config.typeName;
      this.updateEditorConfig()
    }
  }

  updateEditorConfig() {
    this.EditorConfig.editable = this.editMode;
  }

  getContent() {
    this.content = this.htmlContent;
    this.sendContent.emit(this.htmlContent)
    return this.htmlContent;
  }
}


